import { render, staticRenderFns } from "./sendinvoice.vue?vue&type=template&id=bf579eb6"
import script from "./sendinvoice.vue?vue&type=script&lang=js"
export * from "./sendinvoice.vue?vue&type=script&lang=js"
import style0 from "./sendinvoice.vue?vue&type=style&index=0&id=bf579eb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports